app.controller("VerifyMailController", ["$scope", "AuthService", "$stateParams",
    function ($scope, AuthService, $stateParams) {
        $scope.status = null;
        AuthService.verifyEmail({token: $stateParams.token}).then(function (data) {
            $scope.status = 'success';
        }).catch(function (err) {
            $scope.status = 'fail';
        });
    }
]);
